module.exports = __webpack_public_path__ + "img/tescoLotus.d159fbc.png";